import { render } from "./hpContact.vue?vue&type=template&id=6ba07686&scoped=true"
import script from "./hpContact.vue?vue&type=script&lang=js"
export * from "./hpContact.vue?vue&type=script&lang=js"

import "./hpContact.vue?vue&type=style&index=0&id=6ba07686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba07686"]])

export default __exports__